// import axios from 'axios'
import axios from "./http";
export default {

  createCampaign(campaign) {
    // console.log(campaign.file_image);

    let formData = new FormData();
    formData.append("campaign", JSON.stringify(campaign));
    //formData.append('Badge', campaign.file_image);

    // for(var key in campaign.file_image){
    //     formData.append('Badge', campaign.file_image[key]);
    // }

    // const config = {
    //     headers: {
    //         'Content-Type': 'multipart/form-data'
    //       }
    // };

    return axios
      .post("/campaign/create", campaign)
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  updateCampaign(campaign) {

    let formData = new FormData();
    formData.append("campaign", JSON.stringify(campaign));

    for (var key in campaign.file_image) {
      formData.append("Badge", campaign.file_image[key]);
    }

    return axios
      .put("/campaign", campaign)
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  duplicateCampaign(campaign) {

    delete campaign._id; // campaign._id = null;

    let formData = new FormData();
    formData.append("campaign", JSON.stringify(campaign));

    // for (var key in campaign.file_image) {
    //   formData.append("Badge", campaign.file_image[key]);
    // }

    return axios.post("/campaign/duplicate", campaign)
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  updateCampaignPublish(campaign) {

    let formData = new FormData();
    formData.append("campaign", JSON.stringify(campaign));

    for (var key in campaign.file_image) {
      formData.append("Badge", campaign.file_image[key]);
    }

    return axios.post("/campaign/update_publish", campaign)
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  getCustomerGroups() {
    return axios.get("/custgroup/get")
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  getPromotions() {
    return axios.get("/promotion/list")
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  deletePromotion(id) {
    return axios.delete("/promotion/delete/" + id)
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  getAllCampaign() {
    return axios.get("/campaign")
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  getAllEvents() {
    let query = {'view':0};
    return axios.get("/campaign/events", query)
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  searchCampaigns(keyword, status, view) {
    return axios.get("/campaign/events", {
        params: {
          keyword: keyword,
          // customers: customers
          //   .map(function(el) {
          //     return el.code;
          //   })
          //   .join(","),
          // products: products
          //   .map(function(el) {
          //     return el.code;
          //   })
          //   .join(","),
          status: status,
          view: view
        }
      })
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  getCampaignById(id) {
    return axios.get("/campaign/" + id)
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  deleteCampaign(id) {
    return axios.delete("/campaign/", {
        data: {
          id: id
        }
      })
      .then(function(response) {
        return Promise.resolve(response);
      })
      .catch(function(error) {
        return Promise.reject(error);
      });
  },
  getReport(){
    return axios.get("/campaign/track")
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
  getReportDelivery(){
    return axios.get("/campaign/delivery")
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
  getReportCompareCost(){
    return axios.get("/campaign/compare-cost")
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
  getConfig(){
    return axios.get("/campaign/config")
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
  saveConfig(form){
    return axios.put("/campaign/config",form)
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
  getReportInfo(id){
    return axios.get("/campaign/report/"+id)
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
  recallCampaign(id){
    return axios.get("/campaign/recall/"+id)
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
  sendToApproveCampaign(campaign_id,boss_code){
    return axios.get("/campaign/send-to-approve/"+campaign_id+'/'+boss_code)
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
  approve(id){
    return axios.put("/campaign/approve/",{id:id})
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
  reject(id){
    return axios.put("/campaign/reject/",{id:id})
    .then(function(response) {
      return Promise.resolve(response);
    })
    .catch(function(error) {
      return Promise.reject(error);
    });
  },
};
